import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { TocPage } from './toc';

const routes: Routes = [
  {
    path: '',
    component: TocPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TocPageRoutingModule { }
